import React from "react"
import "./TitleBox.css"
const TitleBox = ({title}) => {
  return <div className="title-box">{title}</div>
}

export default TitleBox
